// Stock store product catalog.
// IMPORTANT:
// - Product IDs are STABLE (kept across reordering / restock).
// - `authentic: true` makes a product appear in BOTH its main category AND the
//   "Authentic Brands" virtual category, and shows the "Authentic Product" badge.
// - `originalPrice: null` means "Price to be updated" — Add-to-Cart is disabled.
// - `sizes` array → product is sold per size with stock tracked per size:
//     [{ label: "3-4 years", qty: 2 }, ...]
//   When omitted, the product is a single-piece product and `quantity` is the
//   total stock.
// - `images[0]` is the cover (used on product cards). Rest is gallery.

export const CURRENCY = "$";
export const DISCOUNT_PERCENT = 50;
export const SHEIN_DISCOUNT_PERCENT = 30;

export const CATEGORIES = ["clothing", "perfumes", "cosmetics", "others"];
export const VIRTUAL_CATEGORIES = ["authentic"];

// SHEIN is a dedicated "mini-store" inside BOB Store. SHEIN products live in
// their own catalog (sheinProducts.js) and never appear in the general "All"
// view — they only show up inside the /stock/shein page.
import { SHEIN_PRODUCTS, SHEIN_SUBCATEGORIES } from "./sheinProducts";
export { SHEIN_SUBCATEGORIES };

// Public artifact URLs (perfume photos uploaded by the user).
const A_POMEGRANATE = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/iloxsvwe_25.PNG";
const A_DIAMOND_IRIS = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/9pjzi6zn_26.PNG";
const A_FRENCH_TOBACCO = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ttymm728_27.PNG";
const A_MUSK_CARDAMOM = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/wm0ts0ji_28.PNG";
const A_BLUE_DIAMOND = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/mnncdhja_29.PNG";

// Perfumes #021–#024 (Ibrahim Al-Qurashi).
const A_GREEK_TOBACCO = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/zwwyr80t_21.PNG";
const A_MUSK_SUGAR = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/5ecttrah_22.PNG";
const A_MUSK_RASPBERRY = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vzqudpuk_23.PNG";
const A_MUSK_ROSE = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/fa2wy2gz_24.PNG";

// Product #001 — Girls Pink Hooded Knit Cardigan with Balloon Appliqués.
const P001_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/njlbqset_01F9A7CF-00EE-41B2-8ABB-F64F20B8AC31.PNG";
const P001_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/dwbpmhjo_BAB5E76A-572E-44AD-B4AF-21C4C4A61EBF.PNG";
const P001_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/kr1kyxqq_1.PNG";

// Product #002 — Girls Knitted Tulle Dress with Ruffle Details (Dusty Pink).
const P002_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/9c9ynkmd_1D3F0A12-FF68-428B-B9E0-53D3D2804B3F.PNG";
const P002_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/c7jamdje_FE8FEE13-C7F7-4A51-AEC3-CCF651C405B3.PNG";
const P002_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/51sxxdjs_2.PNG";

// Product #003 — Kids OUR Sweatshirt & Jogger Set (Pale Yellow).
const P003_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/9j730c38_FD0E2BA4-0D31-41AD-98A0-04D26A2AA064%20copy.png";
const P003_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/88bmarzx_3.png";
const P003_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/7t18hd62_D8F37FFB-E076-4613-87FC-AD690E906A67%20copy.png";

// Product #004 — Kids Basic Sweatshirt & Jogger Set (Light Blue/Shikalu).
const P004_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/cbjbt1qd_EDA03247-D99F-4D43-8E33-423D4D3E3B42.PNG";
const P004_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vkbucloa_4.PNG";
const P004_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/bnpr7o49_DA59971D-11DF-469C-845A-52F541E49E70.PNG";

// Product #005 — Kids OUR Sweatshirt & Jogger Set (Dark Green).
const P005_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/rqm9cc6j_BFA3E149-16ED-411D-B2AD-CA41A6FFD463.PNG";
const P005_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/7976g7el_5.PNG";
const P005_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/4ew6o7s7_920866F0-F9D1-442A-A133-9E085A5B676B.PNG";

// Product #006 — Kids OUR Sweatshirt & Jogger Set (Light Grey).
const P006_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/y17s0rc1_BB8463A6-D075-43DC-904D-457AA16A492F.PNG";
const P006_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/l6ohyn8z_6.PNG";
const P006_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ucmp9ad6_A2433EEA-EF5F-4B7A-82DF-768192F531B0.PNG";

// Product #007 — Adidas Track Jogger Pants (Navy with 3-Stripes).
const P007_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/qqqpl8gg_B553293C-EA60-4DDC-9688-489EEF46758F.PNG";
const P007_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/2nmc40j7_7.PNG";
const P007_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ujbeiss7_781AFE92-2860-4DBF-BC9C-87332403953A.PNG";

// Product #008 — Girls Bow Knit Cardigan (Grey, Sequin Bow).
const P008_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/4rik91zf_e369842f-bd9c-41fa-9424-c1fac0ab7260.JPG";
const P008_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/nebsluwx_21F42FEE-478F-4786-8F9C-A58BBAC0AAF9.PNG";
const P008_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ptmrgl4q_617F9135-AA18-48F7-AD51-AC500A350BA3.PNG";

// Product #009 — Girls Sequin Tulle Skirt (Grey).
const P009_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/81x8w0uk_EFD239D0-56A5-47B5-9965-BFE47CD89DE3.PNG";
const P009_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/apawaxbr_364E72A2-7DA7-471B-BC12-B3B55A1C438F.PNG";
const P009_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/dt77puax_86353AA8-8FBA-424F-A6E9-77BED6130D64.PNG";

// Product #010 — Girls Sequin Tulle Skirt (Black).
const P010_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/tgri8qhj_43BE0B80-B953-4CD7-98EB-09DF39C0BA49.PNG";
const P010_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/xrge7206_4A6B6389-C93F-455D-A001-FE3864275906.PNG";
const P010_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/0l5shhey_6FCE8136-0041-4B29-9C2D-056C5C8ACC0C.PNG";

// Product #011 — Girls Faux Fur Belted Coat (Blush Pink).
const P011_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/rghwwof2_493DA3C9-A880-44E0-A780-170E81C0EAE6.PNG";
const P011_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/0zaw7y46_6ECCBC67-937B-41FE-B8B9-E294E149C1B7.PNG";
const P011_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/9recl8fk_11.PNG";

// Product #012 — Kids Hooded Duffle Coat (Denim Blue with Toggle Buttons).
const P012_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/e0ey1uup_12.PNG";
const P012_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/76j8v1ae_80A8218B-6C5D-4573-B10E-753A61F392F3.PNG";
const P012_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/9yq2dc0h_4F9FC98E-F1B6-45D0-B405-FDAF74271A1A.PNG";

// Product #014 — Kids SHIKALU Basic Sweatshirt & Jogger Set (Pink).
const P014_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/q3un2ytz_D1B054A7-093E-41F1-A625-3C44C8C82FB3.PNG";
const P014_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vei560ev_14.PNG";
const P014_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/mnx6soy0_82C0A3AA-CA38-4C80-A879-C048DCDAAB13.PNG";

// Product #015 — Zara Black Embroidered Ruffle Blouse.
const P015_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/qdup2ygu_D0086ADB-C222-41B4-83BA-00C5BA30D732.PNG";
const P015_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/bu0aobgd_17B39681-C2B4-48A6-8850-2EE67705A48D.PNG";
const P015_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/754qq98f_429832F8-6FB1-49E8-B933-9DC773679DCE.PNG";

// Product #016 — Girls Sequin Bow Knit Cardigan (Red).
const P016_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/y17ey2dt_16.PNG";
const P016_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/xs43oygr_4C9D6961-0990-40CF-BBE2-AFD0F5593A64.PNG";
const P016_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ysda0ssp_07E00395-EC29-4153-820C-050FB2FF4283.PNG";

// Product #017 — Barrow G1/4" 90° Rotary Adapter TWT90S-V2.
const P017_PRODUCT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/o0ebk0f4_17.PNG";
const P017_PKG_ORANGE = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ob3ul6lw_17.2.PNG";
const P017_PKG_BLACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/8wd54mjf_17.3.PNG";

// Product #018 — Barrow Coolant for Computer 1400 ml.
const P018_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ytnk8up4_18.PNG";
const P018_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/qoy57knk_18.2.PNG";

// Product #019 — Kids Star Detail Sneakers with Beaded Laces (White + Hot Pink).
const P019_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/q7c190jf_19.PNG";
const P019_ONFOOT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/c35lxf9d_19.2.PNG";

// Product #020 — Kurdistan Flag Map Pendant Necklace.
const P020_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/mtwdevc5_20.PNG";

// Product #029 — Ibrahim Al-Qurashi Ibraq Musk (75 ml box).
const P029_BOX = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/b2w7nq4x_29.PNG";

// Product #028 — Blue Diamond Aqua 200 ml (premium box on icy background).
const P028_BOX = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/hbwjqrx6_28.PNG";

// Product #032 — Marks & Spencer Baby Elf Christmas Outfit Set (Green/Navy).
const P032_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/zos1xikc_32.1.PNG";
const P032_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/iu9qdcrh_32.PNG";
const P032_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/mgyvh79c_32.2.PNG";

// Product #033 — Alo Yoga Women's Accolade Straight Leg Sweatpants (Athletic Heather Grey).
const P033_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/6hwvxu8n_33.PNG";
const P033_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vhi2gnwn_33.1.PNG";
const P033_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/u3m8hnq9_33.2.PNG";

// Product #034 — Alo Yoga Unisex Half-Crew Understated Socks (Brown, Medium).
const P034_PACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/xq58p5mh_34.2.PNG";
const P034_ONFOOT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/y6qkb7kd_34.PNG";
const P034_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/y03p0yd3_34.1.PNG";

// Product #039 — Marks & Spencer Baby Girls Red Christmas Outfit Set.
const P039_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/6v3d6m6t_39.PNG";
const P039_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vbpsg6tk_39.1.PNG";
const P039_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ox1nirkd_39.2.PNG";

// Product #040 — Marks & Spencer Baby Santa Claus Christmas Outfit Set.
const P040_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/i1iezvuj_40.PNG";
const P040_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/hkzcogkn_40.2.PNG";
const P040_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/lpd98x7n_40.1.PNG";

// Product #043 — Marks & Spencer Baby Christmas Cardigan Outfit Set (Dark Grey + Cream).
const P043_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/qlya1v0g_43.2.PNG";
const P043_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/on1nvlcd_43.1.PNG";
const P043_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/f68e5hcj_43.PNG";

// Product #037 — Marks & Spencer Baby Christmas Holly Print Outfit Set (Cream).
const P037_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/nlztbw04_37.1.PNG";
const P037_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/4fsdeggy_37.PNG";
const P037_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ssone6ae_37.2.PNG";

// Product #038 — Baby Hooded Quilted Snowsuit with Mittens (Blush Pink).
const P038_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/fxjjrwoh_38.2.PNG";
const P038_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/boifu2gy_38.PNG";
const P038_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vd9t0f8d_38.1.PNG";

// Product #030 — Marks & Spencer Baby Girls Floral Shirt & Fleece Vest Outfit Set (Beige).
const P030_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/7mqstner_30.PNG";
const P030_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/grdb7td0_30.1.PNG";
const P030_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/v25hpjsg_30.2.PNG";

// Product #041 — Dolce & Gabbana Milano Girls White Tie-Front T-Shirt & Yellow Printed Shorts Set.
const P041_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/azmw4hou_41.PNG";
const P041_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/2kcxajq7_41.1.PNG";
const P041_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/zryk522x_41.2.PNG";

// Product #035 — Timberland Baby Boys Beige Short Dungarees.
const P035_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vbsvw21i_35.1.PNG";
const P035_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/vb5w71ae_35.PNG";
const P035_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ihwe0kde_35.2.PNG";

// Product #031 — Timberland Boys White Long Sleeve Polo Shirt.
const P031_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/4176tlz5_31.2.PNG";
const P031_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/zw1q1exb_31.PNG";
const P031_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/a3fqcifr_31.1.PNG";

// Product #036 — BOSS Kids Blue & Black Velcro Sandals.
const P036_SIDE = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/xeknlam4_36.PNG";
const P036_TOP = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/5060s9ne_36.2.PNG";
const P036_ONFOOT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/pi3o9x6y_36.1.PNG";
const P036_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/tdchbt4m_36.3.PNG";

// ===== Supplements & Cosmetics images =====
// Product #045 — Nature's Bounty B-12 1000mcg.
const P045_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/99itp0zp_45.PNG";
const P045_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ffb6vfl1_45.2.PNG";

// Product #044 — EVLution Nutrition L-Theanine 200mg – 60 Veggie Capsules.
const P044_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/dksd90e8_44.PNG";
const P044_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/jrt6fn6k_44.2.PNG";

// Product #046 — NOW Magnesium Glycinate – 180 Tablets.
const P046_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/0yz0zyz7_46.PNG";
const P046_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/s28yq4nt_46.2.PNG";

// Product #047 — Sunny's Studio Supplements Liposomal Vitamin C 1500mg – 180 Capsules.
const P047_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/iaea391a_47.PNG";
const P047_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/d2c5wwit_47.2.PNG";

// Product #048 — California Gold Nutrition Resveratrol Complex 500mg.
const P048_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/sw4n8tz2_48.PNG";
const P048_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ggm3xgl6_48.2.PNG";

// Product #049 — Micro Ingredients Liver Detox Cleanse & Repair – 240 Vegetarian Capsules.
const P049_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/7n3feers_49.PNG";
const P049_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/t3wdszar_49.2.PNG";

// Product #050 — Nutricost Magnesium Malate Powder 420mg – 300g.
const P050_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ixmqbmwk_50.PNG";
const P050_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/i6xs2nty_50.2.PNG";

// ===== Others category (Tools / Lifestyle) =====
// Product #063 — MAX Wireless Tattoo Pen Machine Kit.
const P063_BOX = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/md07t73k_50.PNG";
const P063_KIT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/xye2u3k9_50.1.PNG";

// Product #052 — ATG Headlight Restoration Kit.
const P052_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/0x9byxhx_52.PNG";
const P052_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/oy769uxb_52.1.PNG";
const P052_KIT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/yl5udq7v_52.2.PNG";

// Product #051 — Brass Gas Cylinder Valve Adapter.
const P051_A = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/iukldm3u_51.PNG";
const P051_B = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/pgc4cay7_51.1.PNG";
const P051_C = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/m5ey6km6_51.2.PNG";

// Product #053 — 3D Teddy Bear LED Night Light.
const P053_LAMP = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/99rs3mmj_53.PNG";
const P053_BOX = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/remv65dc_53.2.PNG";

// Product #056 — SS001 Pro Pick & Decode Tool.
const P056 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/2bi7mjnx_56.JPG";

// Product #058 — White 2-Tier Cupcake Stand.
const P058 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/6z5x5u27_58.PNG";

// Product #059 — Digital Body Fat Caliper.
const P059 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/cgujnjqs_59.PNG";

// Product #060 — Engine Hour Meter.
const P060 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/ev5byz9e_60.PNG";

// Product #061 — Happy Float Balloon Brightener Spray 450ml.
const P061 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/o8kpefan_61.PNG";

// Product #054 — Stainless Steel Layered Bar Pendant Necklace.
const P054 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/q8x0jg0l_54.PNG";

// Product #055 — Razer Black Carrying Case.
const P055 = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/d2uapnbj_55.JPG";

// Product #062 — Tubular Lock Pick Tool Kit (3-piece set).
const P062_MANUAL = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/g65bycpx_62.PNG";
const P062_KIT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/oewy75e2_62.2.PNG";

// === Batch 18, 2026 — 3 new products ===
// Hosted in /app/frontend/public/products/* so they ship with the build
// and avoid extra customer-assets uploads. CSV-order: main, 2, 3.
const P065_MAIN = "/products/65.2.PNG";
const P065_PACK = "/products/65.3.PNG";
const P065_HERO = "/products/65.PNG";

const P066_MAIN = "/products/66.2.PNG";
const P066_DETAIL = "/products/66.3.png";
const P066_HERO = "/products/66.PNG";

const P067_MAIN = "/products/67.2.png";
const P067_DETAIL = "/products/67.3.PNG";
const P067_HERO = "/products/67.PNG";

// Product #042 — Columbia Men's Brown Cargo Belted Pants (Camel, Size 32).
const P042_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/kog5hclm_42.PNG";
const P042_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/u10nkvz2_42.1.PNG";
const P042_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/5vymi3tg_42.2.PNG";

// Product #013 — Girls Layered Tulle Ruffle Skirt (Cream with Pink Ombre Trim).
const P013_FLAT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/b9ofnp5g_5D4A5F39-C45C-4D6A-BB6C-82AD2AA7A97D.PNG";
const P013_BACK = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/rlb1o2g7_7175E5E0-15AA-46FD-AF81-4B12C2D28420.PNG";
const P013_FRONT = "https://customer-assets.emergentagent.com/job_bob-global-shop/artifacts/gqplbmpp_D790CEE9-D125-4249-973C-8DA4C7253EB4.PNG";

// Featured artwork rotated in the 50% OFF promo banner background.
// Curated premium global-shopping / fashion / retail imagery (Unsplash).
// All hand-picked: logo-free, editorial mood, aligned with BOB black/orange identity.
// Images sized to w=1400 for solid mobile loading without quality loss.
export const PROMO_CAROUSEL_IMAGES = [
  // Luxury shopper carrying premium shopping bags (cosmopolitan)
  "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1400&q=80&auto=format&fit=crop",
  // Red & black shopping bags arranged on dark background (matches BOB identity)
  "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=1400&q=80&auto=format&fit=crop",
  // Premium boutique window — curated apparel display
  "https://images.unsplash.com/photo-1445205170230-053b83016050?w=1400&q=80&auto=format&fit=crop",
  // Fashion editorial — model with vintage sunglasses
  "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=1400&q=80&auto=format&fit=crop",
  // Vintage chic styling — fashion-forward
  "https://images.unsplash.com/photo-1581338834647-b0fb40704e21?w=1400&q=80&auto=format&fit=crop",
];

const placeholder = (id, label) =>
  `https://placehold.co/1000x1250/0A0A0A/F37021/png?text=Product+%23${id}%0A${encodeURIComponent(label)}`;

// helper to build size objects
const sizes = (...pairs) => pairs.map(([label, qty]) => ({ label, qty }));

export const PRODUCTS = [
  // ===== CLOTHING & SHOES =====
  {
    id: "001",
    name: {
      en: "Girls Pink Hooded Knit Cardigan with Colorful Balloon Appliqués",
      ar: "كارديغان بناتي وردي بكابيشون ومزيّن بأشكال بالونات ملوّنة",
      fr: "Cardigan tricoté à capuche pour filles avec appliqués ballons colorés",
    },
    category: "clothing", authentic: false,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    quantity: 1,
    sizes: sizes(["2 years", 1]),
    originalPrice: 25,
    tags: [],
    images: [P001_FLAT, P001_FRONT, P001_BACK],
  },
  {
    id: "002",
    name: {
      en: "Girls Knitted Tulle Dress with Ruffle Details",
      ar: "فستان بناتي تول مع تطريز كشكش",
      fr: "Robe en tulle tricoté pour filles avec détails à volants",
    },
    category: "clothing", authentic: false,
    color: { en: "Dusty Pink", ar: "وردي مغبّر", fr: "Rose poudré" },
    quantity: 1,
    sizes: sizes(["3-4 years", 1]),
    originalPrice: 30,
    tags: [],
    images: [P002_FLAT, P002_FRONT, P002_BACK],
  },
  {
    id: "003",
    name: {
      en: "Kids OUR Sweatshirt & Jogger Set",
      ar: "طقم سويتشيرت وبنطلون أطفال OUR",
      fr: "Ensemble sweat & jogger enfant OUR",
    },
    category: "clothing", authentic: false,
    color: { en: "Pale Yellow", ar: "أصفر باهت", fr: "Jaune pâle" },
    sizes: sizes(
      ["1.5-2 years", 1], ["2-3 years", 1], ["3-4 years", 1], ["5-6 years", 1]
    ),
    originalPrice: 20,
    tags: ["new"],
    images: [P003_FLAT, P003_FRONT, P003_BACK],
  },
  {
    id: "004",
    name: {
      en: "Kids Basic Sweatshirt & Jogger Set",
      ar: "طقم سويتشيرت وبنطلون أطفال أساسي",
      fr: "Ensemble sweat & jogger enfant basique",
    },
    category: "clothing", authentic: false,
    color: { en: "Light Grey", ar: "رمادي فاتح", fr: "Gris clair" },
    sizes: sizes(["1.5-2 years", 2], ["2-3 years", 2], ["3-4 years", 3]),
    originalPrice: 20,
    tags: [],
    images: [P004_FLAT, P004_FRONT, P004_BACK],
  },
  {
    id: "005",
    name: {
      en: "Kids OUR Sweatshirt & Jogger Set",
      ar: "طقم سويتشيرت وبنطلون أطفال OUR",
      fr: "Ensemble sweat & jogger enfant OUR",
    },
    category: "clothing", authentic: false,
    color: { en: "Dark Green", ar: "أخضر داكن", fr: "Vert foncé" },
    sizes: sizes(
      ["1.5-2 years", 1], ["2-3 years", 1], ["3-4 years", 1], ["5-6 years", 1]
    ),
    originalPrice: 20,
    tags: [],
    images: [P005_FLAT, P005_FRONT, P005_BACK],
  },
  {
    id: "006",
    name: {
      en: "Kids OUR Sweatshirt & Jogger Set",
      ar: "طقم سويتشيرت وبنطلون أطفال OUR",
      fr: "Ensemble sweat & jogger enfant OUR",
    },
    category: "clothing", authentic: false,
    color: { en: "Light Grey", ar: "رمادي فاتح", fr: "Gris clair" },
    sizes: sizes(
      ["1.5-2 years", 1], ["2-3 years", 1], ["3-4 years", 1], ["5-6 years", 1]
    ),
    originalPrice: 20,
    tags: [],
    images: [P006_FLAT, P006_FRONT, P006_BACK],
  },
  {
    id: "007",
    name: {
      en: "Adidas Track Jogger Pants with 3-Stripes Detail",
      ar: "بنطلون رياضي أديداس بثلاث خطوط",
      fr: "Pantalon de jogging Adidas avec détail 3 bandes",
    },
    category: "clothing", authentic: true,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    sizes: sizes(["5XL", 1]),
    originalPrice: 60,
    tags: [],
    images: [P007_FLAT, P007_FRONT, P007_BACK],
  },
  {
    id: "008",
    name: {
      en: "Girls Bow Knit Cardigan",
      ar: "كارديغان بناتي مزيّن بفيونكة",
      fr: "Cardigan tricoté pour filles avec nœud",
    },
    category: "clothing", authentic: false,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    sizes: sizes(
      ["2-3", 1], ["3-4", 1], ["4-5", 1], ["5-6", 1], ["6-7", 1], ["7-8", 1]
    ),
    originalPrice: 25,
    tags: [],
    images: [P008_FLAT, P008_FRONT, P008_BACK],
  },
  {
    id: "009",
    name: {
      en: "Girls Sequin Tulle Skirt",
      ar: "تنورة بناتي تول مرصّعة بالترتر",
      fr: "Jupe en tulle à sequins pour filles",
    },
    category: "clothing", authentic: false,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    sizes: sizes(
      ["2-3", 1], ["3-4", 1], ["4-5", 1], ["5-6", 1], ["6-7", 1], ["7-8", 1]
    ),
    originalPrice: 25,
    tags: [],
    images: [P009_FLAT, P009_FRONT, P009_BACK],
  },
  {
    id: "010",
    name: {
      en: "Girls Sequin Tulle Skirt",
      ar: "تنورة بناتي تول مرصّعة بالترتر",
      fr: "Jupe en tulle à sequins pour filles",
    },
    category: "clothing", authentic: false,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: sizes(
      ["2-3", 1], ["3-4", 1], ["4-5", 1], ["5-6", 1], ["6-7", 1], ["7-8", 1]
    ),
    originalPrice: 25,
    tags: [],
    images: [P010_FLAT, P010_FRONT, P010_BACK],
  },
  {
    id: "011",
    name: {
      en: "Girls Faux Fur Belted Coat",
      ar: "معطف بناتي بفرو صناعي وحزام",
      fr: "Manteau pour filles en fausse fourrure ceinturée",
    },
    category: "clothing", authentic: false,
    color: { en: "Blush Pink", ar: "وردي خدّي", fr: "Rose blush" },
    quantity: 1,
    sizes: sizes(["3-4 years", 1]),
    originalPrice: 40,
    tags: [],
    images: [P011_FLAT, P011_FRONT, P011_BACK],
  },
  {
    id: "012",
    name: {
      en: "Kids Hooded Duffle Coat with Toggle Buttons",
      ar: "معطف أطفال داف بكابيشون وأزرار",
      fr: "Manteau duffle-coat enfant à capuche avec boutons à brides",
    },
    category: "clothing", authentic: false,
    color: { en: "Denim Blue", ar: "أزرق دنيم", fr: "Bleu denim" },
    quantity: 1,
    sizes: sizes(["3-4 years", 1]),
    originalPrice: 50,
    tags: [],
    images: [P012_FLAT, P012_FRONT, P012_BACK],
  },
  {
    id: "013",
    name: {
      en: "Girls Layered Tulle Ruffle Skirt",
      ar: "تنورة بناتي تول متعدّدة الطبقات بكشكش",
      fr: "Jupe en tulle à volants superposés pour filles",
    },
    category: "clothing", authentic: false,
    color: { en: "Cream with Pink Ombre Trim", ar: "كريمي مع حاشية وردية متدرّجة", fr: "Crème avec liseré rose dégradé" },
    quantity: 1,
    sizes: sizes(["3-4 years", 1]),
    originalPrice: 25,
    tags: [],
    images: [P013_FLAT, P013_FRONT, P013_BACK],
  },
  {
    id: "014",
    name: {
      en: "Kids Basic Sweatshirt & Jogger Set",
      ar: "طقم سويتشيرت وبنطلون أطفال أساسي",
      fr: "Ensemble sweat & jogger enfant basique",
    },
    category: "clothing", authentic: false,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: sizes(["1.5-2 years", 3], ["2-3 years", 4], ["3-4 years", 4]),
    originalPrice: 20,
    tags: [],
    images: [P014_FLAT, P014_FRONT, P014_BACK],
  },
  {
    id: "015",
    name: {
      en: "Zara Black Embroidered Ruffle Blouse",
      ar: "بلوزة زارا سوداء مطرّزة بكشكش",
      fr: "Blouse Zara noire brodée à volants",
    },
    category: "clothing", authentic: true,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: sizes(["XS", 1]),
    originalPrice: 80,
    tags: [],
    images: [P015_FLAT, P015_FRONT, P015_BACK],
  },
  {
    id: "016",
    name: {
      en: "Girls Bow Knit Cardigan",
      ar: "كارديغان بناتي مزيّن بفيونكة",
      fr: "Cardigan tricoté pour filles avec nœud",
    },
    category: "clothing", authentic: false,
    color: { en: "Burgundy", ar: "خمري", fr: "Bordeaux" },
    sizes: sizes(
      ["2-3", 1], ["3-4", 1], ["4-5", 1], ["5-6", 1], ["6-7", 1], ["7-8", 1]
    ),
    originalPrice: 25,
    tags: [],
    images: [P016_FLAT, P016_FRONT, P016_BACK],
  },

  // ===== OTHERS =====
  {
    id: "017",
    name: {
      en: "Barrow G1/4\" 90° Rotary Adapter — TWT90S-V2",
      ar: "محوّل دوّار باراو G1/4 90° — TWT90S-V2",
      fr: "Adaptateur rotatif 90° G1/4 Barrow — TWT90S-V2",
    },
    category: "others", authentic: false,
    quantity: 3,
    originalPrice: 2,
    tags: [],
    images: [P017_PRODUCT, P017_PKG_ORANGE, P017_PKG_BLACK],
  },
  {
    id: "018",
    name: {
      en: "Barrow Coolant for Computer — 1400 ml",
      ar: "سائل تبريد باراو للكمبيوتر — 1400 مل",
      fr: "Liquide de refroidissement Barrow pour PC — 1400 ml",
    },
    category: "others", authentic: false,
    quantity: 2,
    originalPrice: 15,
    tags: [],
    images: [P018_FRONT, P018_BACK],
  },
  {
    id: "019",
    name: {
      en: "Kids Star Detail Sneakers with Beaded Laces",
      ar: "حذاء أطفال بنجمة ورباطات بخرز",
      fr: "Baskets enfant à étoile avec lacets perlés",
    },
    category: "clothing", authentic: false,
    color: { en: "White with Hot Pink", ar: "أبيض مع وردي فاقع", fr: "Blanc et rose vif" },
    quantity: 1,
    sizes: sizes(["EU 26", 1]),
    originalPrice: 40,
    tags: [],
    images: [P019_FLAT, P019_ONFOOT],
  },
  {
    id: "020",
    name: {
      en: "Kurdistan Flag Map Pendant Necklace",
      ar: "قلادة بشكل خريطة علم كردستان",
      fr: "Collier pendentif carte drapeau du Kurdistan",
    },
    category: "others", authentic: false,
    color: { en: "Gold", ar: "ذهبي", fr: "Doré" },
    quantity: 120,
    originalPrice: 2,
    tags: [],
    images: [P020_FLAT],
  },

  // ===== PERFUMES (all Authentic) =====
  {
    id: "021",
    name: {
      en: "Ibraheem Al-Qurashi Greek Tobacco Extrait de Parfum — 200 ml",
      ar: "إبراهيم القرشي توباكو يوناني — 200 مل",
      fr: "Ibraheem Al-Qurashi Tabac Grec Extrait de Parfum — 200 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 80,
    tags: [],
    images: [A_GREEK_TOBACCO],
  },
  {
    id: "022",
    name: {
      en: "Ibrahim Al-Qurashi Ibraq Musk Sugar Eau de Parfum — 75 ml",
      ar: "إبراهيم القرشي إبراق مسك السكّر — 75 مل",
      fr: "Ibrahim Al-Qurashi Ibraq Musc Sucre EDP — 75 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 80,
    tags: [],
    images: [A_MUSK_SUGAR],
  },
  {
    id: "023",
    name: {
      en: "Ibraheem Al-Qurashi IBRAQ — Musk Raspberry 75 ml",
      ar: "إبراهيم القرشي إبراق — مسك رازبيري 75 مل",
      fr: "Ibraheem Al-Qurashi IBRAQ — Musc Raspberry 75 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 60,
    tags: [],
    images: [A_MUSK_RASPBERRY],
  },
  {
    id: "024",
    name: {
      en: "Ibrahim Al-Qurashi Ibraq Musk Rose Eau de Parfum — 75 ml",
      ar: "إبراهيم القرشي إبراق مسك الورد — 75 مل",
      fr: "Ibrahim Al-Qurashi Ibraq Musc Rose EDP — 75 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 60,
    tags: [],
    images: [A_MUSK_ROSE],
  },
  {
    id: "025",
    name: {
      en: "Ibraheem Al-Qurashi Greek Tobacco Extrait de Parfum — 200 ml",
      ar: "إبراهيم القرشي توباكو يوناني إكستريه دو بارفان — 200 مل",
      fr: "Ibraheem Al-Qurashi Tabac Grec Extrait de Parfum — 200 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 80,
    tags: [],
    images: [A_DIAMOND_IRIS],
  },
  {
    id: "026",
    name: {
      en: "Ibrahim Al-Qurashi Musk Abraq Pomegranate Eau de Parfum — 75 ml",
      ar: "إبراهيم القرشي مسك عبق الرمّان — 75 مل",
      fr: "Ibrahim Al-Qurashi Musc Abraq Grenade Eau de Parfum — 75 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 60,
    tags: [],
    images: [A_FRENCH_TOBACCO],
  },
  {
    id: "027",
    name: {
      en: "Ibrahim Al-Qurashi Golden Diamond Iris Eau de Parfum — 200 ml",
      ar: "إبراهيم القرشي ألماس الذهب آيرس — 200 مل",
      fr: "Ibrahim Al-Qurashi Golden Diamond Iris Eau de Parfum — 200 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 80,
    tags: [],
    images: [A_POMEGRANATE],
  },
  {
    id: "028",
    name: {
      en: "Ibrahim Al-Qurashi Blue Diamond Aqua Eau de Parfum — 200 ml",
      ar: "إبراهيم القرشي بلو دايموند أكوا — 200 مل",
      fr: "Ibrahim Al-Qurashi Blue Diamond Aqua Eau de Parfum — 200 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 80,
    tags: [],
    images: [P028_BOX],
  },
  {
    id: "029",
    name: {
      en: "Ibraheem Al-Qurashi Ibraq Musk Pomegranate Eau de Parfum — 75 ml",
      ar: "إبراهيم القرشي إبراق مسك الرمّان — 75 مل",
      fr: "Ibraheem Al-Qurashi Ibraq Musc Grenade Eau de Parfum — 75 ml",
    },
    category: "perfumes", authentic: true,
    quantity: 1,
    originalPrice: 60,
    tags: [],
    images: [P029_BOX],
  },

  // ===== AUTHENTIC ALO YOGA (Clothing) =====
  {
    id: "030",
    name: {
      en: "Marks & Spencer Baby Girls Floral Shirt & Fleece Vest Outfit Set",
      ar: "طقم بناتي قميص مزهّر وفيست فرو Marks & Spencer",
      fr: "Ensemble bébé fille chemise fleurie et gilet polaire Marks & Spencer",
    },
    category: "clothing", authentic: true,
    color: { en: "Beige", ar: "بيج", fr: "Beige" },
    quantity: 1,
    sizes: sizes(["2-3 years", 1]),
    originalPrice: 60,
    tags: ["new"],
    images: [P030_FLAT, P030_FRONT, P030_BACK],
  },
  {
    id: "031",
    name: {
      en: "Timberland Boys White Long Sleeve Polo Shirt",
      ar: "بولو ولادي بأكمام طويلة Timberland أبيض",
      fr: "Polo manches longues garçon Timberland blanc",
    },
    category: "clothing", authentic: true,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    quantity: 1,
    sizes: sizes(["2 years", 1]),
    originalPrice: 56,
    tags: ["new"],
    images: [P031_FLAT, P031_FRONT, P031_BACK],
  },
  {
    id: "032",
    name: {
      en: "Marks & Spencer Baby Elf Christmas Outfit Set",
      ar: "طقم قزم الميلاد للأطفال Marks & Spencer أخضر",
      fr: "Ensemble Lutin de Noël bébé Marks & Spencer vert",
    },
    category: "clothing", authentic: true,
    color: { en: "Green", ar: "أخضر", fr: "Vert" },
    sizes: sizes(["3-6 months", 1], ["9-12 months", 1]),
    originalPrice: 46,
    tags: ["new"],
    images: [P032_FLAT, P032_FRONT, P032_BACK],
  },
  {
    id: "033",
    name: {
      en: "Alo Yoga Women's Accolade Straight Leg Sweatpants",
      ar: "بنطلون رياضي نسائي Alo Yoga Accolade مستقيم الساق",
      fr: "Pantalon de survêtement droit Alo Yoga Femme Accolade",
    },
    category: "clothing", authentic: true,
    color: { en: "Athletic Heather Grey", ar: "رمادي أثيلتيك", fr: "Gris athlétique chiné" },
    quantity: 1,
    sizes: sizes(["XXS", 1]),
    originalPrice: 150,
    tags: ["new"],
    images: [P033_FLAT, P033_FRONT, P033_BACK],
  },
  {
    id: "034",
    name: {
      en: "Alo Yoga Unisex Half-Crew Understated Socks",
      ar: "جوارب Alo Yoga متوسطة الطول للجنسين Understated",
      fr: "Chaussettes Alo Yoga mi-mollet unisexes Understated",
    },
    category: "clothing", authentic: true,
    color: { en: "Brown", ar: "بنّي", fr: "Marron" },
    quantity: 1,
    sizes: sizes(["M", 1]),
    originalPrice: 50,
    tags: ["new"],
    images: [P034_PACK, P034_ONFOOT, P034_BACK],
  },
  {
    id: "035",
    name: {
      en: "Timberland Baby Boys Beige Short Dungarees",
      ar: "أوفرول قصير ولادي رضيع Timberland بيج",
      fr: "Salopette courte bébé garçon Timberland beige",
    },
    category: "clothing", authentic: true,
    color: { en: "Beige", ar: "بيج", fr: "Beige" },
    quantity: 1,
    sizes: sizes(["2 years", 1]),
    originalPrice: 70,
    tags: ["new"],
    images: [P035_FLAT, P035_FRONT, P035_BACK],
  },
  {
    id: "036",
    name: {
      en: "BOSS Kids Blue & Black Velcro Sandals",
      ar: "صندل أطفال BOSS بفيلكرو أزرق وأسود",
      fr: "Sandales enfant BOSS à scratch bleu et noir",
    },
    category: "clothing", authentic: true,
    color: { en: "Blue & Black", ar: "أزرق وأسود", fr: "Bleu et noir" },
    quantity: 1,
    sizes: sizes(["EU 19", 1]),
    originalPrice: 76,
    tags: ["new"],
    images: [P036_ONFOOT, P036_TOP, P036_SIDE, P036_BACK],
  },
  {
    id: "037",
    name: {
      en: "Marks & Spencer Baby Christmas Holly Print Outfit Set",
      ar: "طقم ميلاد للأطفال بطبعة الهولي Marks & Spencer كريمي",
      fr: "Ensemble Noël bébé imprimé Houx Marks & Spencer crème",
    },
    category: "clothing", authentic: true,
    color: { en: "Cream", ar: "كريمي", fr: "Crème" },
    quantity: 1,
    sizes: sizes(["9-12 months", 1]),
    originalPrice: 40,
    tags: ["new"],
    images: [P037_BACK, P037_FLAT, P037_FRONT],
  },
  {
    id: "038",
    name: {
      en: "Marks & Spencer Baby Hooded Quilted Snowsuit with Mittens",
      ar: "بدلة شتوية مبطّنة بقبّعة وقفازات للأطفال Marks & Spencer",
      fr: "Combinaison d'hiver matelassée à capuche avec moufles Marks & Spencer",
    },
    category: "clothing", authentic: true,
    color: { en: "Blush Pink", ar: "وردي خدّي", fr: "Rose blush" },
    quantity: 1,
    sizes: sizes(["6-9 months", 1]),
    originalPrice: 80,
    tags: ["new"],
    images: [P038_FRONT, P038_FLAT, P038_BACK],
  },
  {
    id: "039",
    name: {
      en: "Marks & Spencer Baby Girls Red Christmas Outfit Set",
      ar: "طقم بناتي رضيعات ميلاد Marks & Spencer أحمر",
      fr: "Ensemble Noël bébé fille Marks & Spencer rouge",
    },
    category: "clothing", authentic: true,
    color: { en: "Red / White Stripes", ar: "أحمر / مخطّط أبيض", fr: "Rouge / Rayures blanches" },
    sizes: sizes(
      ["3-6 months", 1], ["6-9 months", 1], ["9-12 months", 1], ["12-18 months", 1]
    ),
    originalPrice: 46,
    tags: ["new"],
    images: [P039_FLAT, P039_FRONT, P039_BACK],
  },
  {
    id: "040",
    name: {
      en: "Marks & Spencer Baby Santa Claus Christmas Outfit Set",
      ar: "طقم بابا نويل للأطفال Marks & Spencer أحمر",
      fr: "Ensemble Père Noël bébé Marks & Spencer rouge",
    },
    category: "clothing", authentic: true,
    color: { en: "Red", ar: "أحمر", fr: "Rouge" },
    sizes: sizes(
      ["3-6 months", 1], ["6-9 months", 1], ["12-18 months", 1], ["18-24 months", 1]
    ),
    originalPrice: 46,
    tags: ["new"],
    images: [P040_FRONT, P040_FLAT, P040_BACK],
  },
  {
    id: "041",
    name: {
      en: "Dolce & Gabbana Milano Girls White Tie-Front T-Shirt & Yellow Printed Shorts Set",
      ar: "طقم Dolce & Gabbana Milano للبنات: تيشيرت أبيض بربطة وشورت مطبوع أصفر",
      fr: "Ensemble fille Dolce & Gabbana Milano : T-shirt blanc à nouer et short imprimé jaune",
    },
    category: "clothing", authentic: true,
    color: { en: "White / Yellow Print", ar: "أبيض / مطبوع أصفر", fr: "Blanc / Imprimé jaune" },
    quantity: 1,
    sizes: sizes(["4-5 years", 1]),
    originalPrice: 250,
    tags: ["new"],
    images: [P041_FRONT, P041_FLAT, P041_BACK],
  },
  {
    id: "042",
    name: {
      en: "Columbia Men's Brown Cargo Belted Pants",
      ar: "بنطلون كارغو رجالي Columbia بنّي مع حزام",
      fr: "Pantalon cargo homme Columbia marron avec ceinture",
    },
    category: "clothing", authentic: true,
    color: { en: "Camel", ar: "جملي", fr: "Camel" },
    quantity: 1,
    sizes: sizes(["32", 1]),
    originalPrice: 80,
    tags: ["new"],
    images: [P042_BACK, P042_FLAT, P042_FRONT],
  },
  {
    id: "043",
    name: {
      en: "Marks & Spencer Baby Christmas Cardigan Outfit Set",
      ar: "طقم كارديغان الميلاد للأطفال Marks & Spencer رمادي داكن",
      fr: "Ensemble cardigan de Noël bébé Marks & Spencer gris foncé",
    },
    category: "clothing", authentic: true,
    color: { en: "Dark Grey / Cream", ar: "رمادي داكن / كريمي", fr: "Gris foncé / Crème" },
    sizes: sizes(["9-12 months", 1], ["2-3 years", 1]),
    originalPrice: 60,
    tags: ["new"],
    images: [P043_FRONT, P043_FLAT, P043_BACK],
  },

  // ===== SUPPLEMENTS & COSMETICS =====
  {
    id: "044",
    name: {
      en: "EVLution Nutrition L-Theanine 200mg – 60 Veggie Capsules",
      ar: "إيفولوشن نيوتريشن إل-ثيانين 200 ملغ – 60 كبسولة نباتية",
      fr: "EVLution Nutrition L-Théanine 200mg – 60 gélules végétales",
    },
    category: "cosmetics", authentic: true,
    quantity: 1,
    originalPrice: 26,
    tags: ["new"],
    images: [P044_FRONT, P044_BACK],
  },
  {
    id: "045",
    name: {
      en: "Nature's Bounty B-12 1000mcg – 200 Coated Tablets",
      ar: "ناتشرز باونتي فيتامين B-12 1000 ميكروغرام – 200 حبة مغلّفة",
      fr: "Nature's Bounty B-12 1000mcg – 200 comprimés enrobés",
    },
    category: "cosmetics", authentic: true,
    quantity: 1,
    originalPrice: 25,
    tags: ["new"],
    images: [P045_FRONT, P045_BACK],
  },
  {
    id: "046",
    name: {
      en: "NOW Magnesium Glycinate – 180 Tablets",
      ar: "ناو مغنيسيوم غلايسينات – 180 حبة",
      fr: "NOW Magnésium Glycinate – 180 comprimés",
    },
    category: "cosmetics", authentic: true,
    quantity: 1,
    originalPrice: 56,
    tags: ["new"],
    images: [P046_FRONT, P046_BACK],
  },
  {
    id: "047",
    name: {
      en: "Sunny's Studio Supplements Liposomal Vitamin C 1500mg – 180 Capsules",
      ar: "سانيز ستوديو فيتامين سي ليبوسومال 1500 ملغ – 180 كبسولة",
      fr: "Sunny's Studio Vitamine C Liposomale 1500mg – 180 gélules",
    },
    category: "cosmetics", authentic: true,
    quantity: 1,
    originalPrice: 46,
    tags: ["new"],
    images: [P047_FRONT, P047_BACK],
  },
  {
    id: "048",
    name: {
      en: "California Gold Nutrition Resveratrol Complex 500mg – 60 Veggie Capsules",
      ar: "كاليفورنيا جولد نيوتريشن مركّب الريسفيراترول 500 ملغ – 60 كبسولة نباتية",
      fr: "California Gold Nutrition Complexe Resvératrol 500mg – 60 gélules végétales",
    },
    category: "cosmetics", authentic: true,
    quantity: 1,
    originalPrice: 20,
    tags: ["new"],
    images: [P048_FRONT, P048_BACK],
  },
  {
    id: "049",
    name: {
      en: "Micro Ingredients Liver Detox Cleanse & Repair – 240 Vegetarian Capsules",
      ar: "مايكرو إنغريديانتس لتنظيف وإصلاح الكبد – 240 كبسولة نباتية",
      fr: "Micro Ingredients Détox & Réparation du Foie – 240 gélules végétales",
    },
    category: "cosmetics", authentic: true,
    quantity: 2,
    originalPrice: 42,
    tags: ["new"],
    images: [P049_FRONT, P049_BACK],
  },
  {
    id: "050",
    name: {
      en: "Nutricost Magnesium Malate Powder 420mg – 300g",
      ar: "نيوتريكوست مغنيسيوم مالات بودرة 420 ملغ – 300 غم",
      fr: "Nutricost Poudre Magnésium Malate 420mg – 300g",
    },
    category: "cosmetics", authentic: true,
    quantity: 1,
    originalPrice: 40,
    tags: ["new"],
    images: [P050_FRONT, P050_BACK],
  },

  // ===== OTHERS (Tools / Lifestyle) =====
  {
    id: "052",
    name: {
      en: "ATG Headlight Restoration Kit",
      ar: "طقم ATG لتلميع وترميم مصابيح السيارة",
      fr: "Kit de rénovation de phares ATG",
    },
    category: "others", authentic: true,
    quantity: 1,
    originalPrice: 15,
    tags: ["new"],
    images: [P052_BACK, P052_FRONT, P052_KIT],
  },
  {
    id: "051",
    name: {
      en: "Brass Gas Cylinder Valve Adapter",
      ar: "وصلة محوّل نحاسية لصمّام أسطوانة الغاز",
      fr: "Adaptateur de valve en laiton pour bouteille de gaz",
    },
    category: "others", authentic: false,
    quantity: 10,
    originalPrice: 8,
    tags: ["new"],
    images: [P051_A, P051_B, P051_C],
  },
  {
    id: "053",
    name: {
      en: "3D Teddy Bear LED Night Light",
      ar: "مصباح ليلي LED بتصميم دب ثلاثي الأبعاد",
      fr: "Veilleuse LED 3D Ourson",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P053_LAMP, P053_BOX],
  },
  {
    id: "056",
    name: {
      en: "SS001 Pro Pick & Decode Tool",
      ar: "أداة SS001 Pro للنسخ وفكّ التشفير",
      fr: "Outil SS001 Pro Pick & Decode",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P056],
  },
  {
    id: "058",
    name: {
      en: "White 2-Tier Cupcake Stand",
      ar: "حامل كب كيك أبيض من طابقين",
      fr: "Présentoir à cupcakes blanc 2 étages",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P058],
  },
  {
    id: "059",
    name: {
      en: "Digital Body Fat Caliper",
      ar: "جهاز قياس نسبة الدهون في الجسم رقمي",
      fr: "Pince à graisse corporelle numérique",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P059],
  },
  {
    id: "060",
    name: {
      en: "Engine Hour Meter (Marine, ATV, Motorcycle, Snowmobile)",
      ar: "عدّاد ساعات المحرك (للقوارب، الدراجات، الموتو)",
      fr: "Compteur d'heures moteur (Marine, ATV, Moto, Motoneige)",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P060],
  },
  {
    id: "061",
    name: {
      en: "Happy Float Balloon Brightener Spray 450ml",
      ar: "سبراي ملمّع البالونات Happy Float 450 مل",
      fr: "Spray brillant pour ballons Happy Float 450ml",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P061],
  },
  {
    id: "054",
    name: {
      en: "Stainless Steel Layered Bar Pendant Necklace",
      ar: "قلادة رجالية متعدّدة الطبقات من الستانلس ستيل",
      fr: "Collier pendentif barre superposé en acier inoxydable",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 5,
    tags: ["new"],
    images: [P054],
  },
  {
    id: "055",
    name: {
      en: "Razer Black Carrying Case",
      ar: "حقيبة حمل سوداء Razer",
      fr: "Étui de transport noir Razer",
    },
    category: "others", authentic: true,
    quantity: 1,
    originalPrice: 10,
    tags: ["new"],
    images: [P055],
  },
  {
    id: "062",
    name: {
      en: "Tubular Lock Pick Tool Kit",
      ar: "طقم أدوات فتح الأقفال الأنبوبية",
      fr: "Kit d'outils crochetage pour serrures tubulaires",
    },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 20,
    tags: ["new"],
    images: [P062_KIT, P062_MANUAL],
  },
  {
    id: "063",
    name: {
      en: "MAX Wireless Tattoo Pen Machine Kit",
      ar: "طقم MAX قلم رسم الوشم اللاسلكي",
      fr: "Kit Stylo Tatouage Sans Fil MAX",
    },
    category: "others", authentic: true,
    quantity: 1,
    originalPrice: 120,
    tags: ["new"],
    images: [P063_BOX, P063_KIT],
  },
  // ===== SUPPLEMENTS & COSMETICS =====
  {
    id: "065",
    name: {
      en: "New Well Liquid Illuminator 3 in 1 — Eye, Lip & Cheek 6 ml",
      ar: "نيو ويل هايلايتر سائل 3 في 1 — للعين والشفاه والخدود 6 مل",
      fr: "New Well Illuminateur Liquide 3 en 1 — yeux, lèvres & joues 6 ml",
    },
    category: "cosmetics", authentic: true,
    color: { en: "Sunset", ar: "صن سيت", fr: "Sunset" },
    quantity: 1,
    originalPrice: 30,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: [P065_MAIN, P065_PACK, P065_HERO],
  },
  // ===== OTHERS =====
  {
    id: "066",
    name: {
      en: "USB Rechargeable MTB Bike Headlight — Waterproof LED Flashlight & Horn",
      ar: "كشاف دراجة MTB USB قابل للشحن — LED مقاوم للماء مع بوق",
      fr: "Phare de VTT USB rechargeable — LED étanche & klaxon",
    },
    category: "others", authentic: false,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: 30,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: [P066_MAIN, P066_DETAIL, P066_HERO],
  },
  {
    id: "067",
    name: {
      en: "Rain Cloud Humidifier with 7-Color Night Light",
      ar: "مرطّب هواء على شكل غيمة مطرية مع إضاءة ليلية بـ7 ألوان",
      fr: "Humidificateur Nuage de Pluie avec veilleuse 7 couleurs",
    },
    category: "others", authentic: false,
    color: { en: "White with Blue Cloud", ar: "أبيض مع غيمة زرقاء", fr: "Blanc avec nuage bleu" },
    quantity: 1,
    originalPrice: 30,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: [P067_MAIN, P067_DETAIL, P067_HERO],
  },

  // ============================================================
  // BATCH 2026-02-19 — 35 new products (#068–#102)
  // Image rule: cover = dotless filename (e.g. "68.png"),
  // gallery = numbered variants (68.2.png, 68.3.png, ...).
  // ============================================================

  // ----- #068 Nike Cortez Sneakers (Clothing & Shoes — Authentic) -----
  {
    id: "068",
    name: {
      en: "Nike Cortez Sneakers",
      ar: "حذاء نايكي كورتيز",
      fr: "Baskets Nike Cortez",
    },
    category: "clothing", authentic: true,
    color: { en: "Black/Cream", ar: "أسود/كريمي", fr: "Noir/Crème" },
    sizes: sizes(["EU 45", 1]),
    originalPrice: 180,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/68.PNG", "/products/68.2.PNG", "/products/68.3.PNG"],
  },

  // ----- #069 Samsung S9 Plus Heavy-Duty Case (Others) -----
  {
    id: "069",
    name: {
      en: "3-in-1 Heavy Duty Armor Case with Belt Clip — Samsung Galaxy S9 Plus",
      ar: "كفر هاتف ثلاثي مقاوم للصدمات مع كليب — سامسونج S9 بلس",
      fr: "Coque 3-en-1 robuste avec clip ceinture — Samsung Galaxy S9 Plus",
    },
    category: "others", authentic: false,
    color: { en: "Fuchsia Pink", ar: "وردي فوشيا", fr: "Rose fuchsia" },
    sizes: sizes(["Galaxy S9 Plus", 1]),
    originalPrice: 20,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/69.png"],
  },

  // ----- #070 BETAFPV Flight Controller (Others) -----
  {
    id: "070",
    name: {
      en: "BETAFPV Air65/75 Brushless Flight Controller — 4-in-1 / 5-in-1 AIO",
      ar: "وحدة تحكّم طيران BETAFPV Air65/75 — AIO 4 في 1 / 5 في 1",
      fr: "Contrôleur de vol BETAFPV Air65/75 — AIO 4-en-1 / 5-en-1",
    },
    category: "others", authentic: false,
    quantity: 2,
    originalPrice: 120,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/70.png", "/products/70.1.png", "/products/70.2.png"],
  },

  // ----- #071 BETAFPV C03 FPV Micro Camera (Others) -----
  {
    id: "071",
    name: {
      en: "BETAFPV C03 FPV Micro Camera",
      ar: "كاميرا BETAFPV C03 FPV ميكرو",
      fr: "Micro caméra FPV BETAFPV C03",
    },
    category: "others", authentic: false,
    quantity: 2,
    originalPrice: 44,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/71.PNG", "/products/71.2.PNG", "/products/71.3.PNG"],
  },

  // ----- #072 BETAFPV Brushless Motors 4-Pack (Others) -----
  {
    id: "072",
    name: {
      en: "BETAFPV 0802II Brushless Motors — 22000KV/25000KV (4-Pack)",
      ar: "محركات BETAFPV 0802II بدون فرش — حزمة 4 قطع",
      fr: "Moteurs sans balais BETAFPV 0802II — pack de 4",
    },
    category: "others", authentic: false,
    sizes: sizes(["4 pcs set", 2]),
    originalPrice: 100,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/72.png", "/products/72.2.png", "/products/72.3.png"],
  },

  // ----- #073 Gemfan 40mm Propellers (Others) -----
  {
    id: "073",
    name: {
      en: "Gemfan 40mm 1610 2-Blade Propellers (4 Pairs)",
      ar: "مراوح Gemfan 40 مم بشفرتين — 4 أزواج",
      fr: "Hélices Gemfan 40 mm à 2 pales (4 paires)",
    },
    category: "others", authentic: false,
    color: { en: "Gray", ar: "رمادي", fr: "Gris" },
    sizes: sizes(["40 mm / 4 pairs", 2]),
    originalPrice: 12,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/73.png"],
  },

  // ----- #074 BT2.0 U-Shape Whoop Pigtail Cables (Others) -----
  {
    id: "074",
    name: {
      en: "BT2.0 U-Shaped 1S Whoop Pigtail Cables (6-Pack)",
      ar: "كابلات BT2.0 1S على شكل حرف U — حزمة 6 قطع",
      fr: "Câbles pigtail BT2.0 1S en U — pack de 6",
    },
    category: "others", authentic: false,
    sizes: sizes(["6 pcs set", 2]),
    originalPrice: 12,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/74.png"],
  },

  // ----- #075 Meteor75 Air II Whoop Frame (Others) -----
  {
    id: "075",
    name: {
      en: "Meteor75 Air II 75mm Brushless Whoop Frame & Canopy",
      ar: "هيكل وغطاء طائرة Meteor75 Air II 75 مم",
      fr: "Châssis & coque Meteor75 Air II 75 mm",
    },
    category: "others", authentic: false,
    sizes: sizes(["75 mm", 2]),
    originalPrice: 32,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/75.png"],
  },

  // ----- #076 Naturelo Prostate & Urinary Health (Supplements — Authentic) -----
  {
    id: "076",
    name: {
      en: "Naturelo Prostate & Urinary Health — 60 Vegetarian Capsules",
      ar: "ناتشريلو مكمّل صحة البروستات والمسالك البولية — 60 كبسولة نباتية",
      fr: "Naturelo Prostate & Urinary Health — 60 capsules végétariennes",
    },
    category: "cosmetics", authentic: true,
    sizes: sizes(["60 capsules", 1]),
    originalPrice: 45,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/76.png", "/products/76.2.png"],
  },

  // ----- #077 Rhode Lip Case iPhone 16 Pro (Others — Authentic) -----
  {
    id: "077",
    name: {
      en: "Rhode Lip Case — iPhone 16 Pro",
      ar: "كفر Rhode Lip Case لآيفون 16 برو",
      fr: "Coque Rhode Lip Case — iPhone 16 Pro",
    },
    category: "others", authentic: true,
    color: { en: "Grey", ar: "رمادي", fr: "Gris" },
    sizes: sizes(["iPhone 16 Pro", 1]),
    originalPrice: 65,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/77.png", "/products/77.2.png"],
  },

  // ----- #078 Alo Yoga Crop Top (Clothing & Shoes — Authentic) -----
  {
    id: "078",
    name: {
      en: "Alo Yoga Alosoft Crop Finesse Short Sleeve",
      ar: "تي شيرت Alo Yoga Alosoft Crop Finesse كم قصير",
      fr: "Top court Alo Yoga Alosoft Crop Finesse — manches courtes",
    },
    category: "clothing", authentic: true,
    color: { en: "Navy", ar: "كحلي", fr: "Marine" },
    sizes: sizes(["Small", 1]),
    originalPrice: 90,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/78.png", "/products/78.2.png", "/products/78.3.png"],
  },

  // ----- #079 Calvin Klein Demi Bra (Clothing & Shoes — Authentic) -----
  {
    id: "079",
    name: {
      en: "Calvin Klein Lightly Lined Demi Bra",
      ar: "صدرية Calvin Klein بحشو خفيف",
      fr: "Soutien-gorge Calvin Klein Lightly Lined Demi",
    },
    category: "clothing", authentic: true,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: sizes(["38C", 1]),
    originalPrice: 48,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/79.png", "/products/79.2.png", "/products/79.3.png"],
  },

  // ----- #080 Levi's Girls Pink Top (Clothing & Shoes — Authentic) -----
  {
    id: "080",
    name: {
      en: "Levi's Girls Pink Floral Logo Long Sleeve Top",
      ar: "بلوزة Levi's بناتي وردية بطبعة الشعار — كم طويل",
      fr: "Top fille Levi's logo floral rose — manches longues",
    },
    category: "clothing", authentic: true,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    sizes: sizes(["XS", 1]),
    originalPrice: 40,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/80.png", "/products/80.2.png", "/products/80.3.png"],
  },

  // ----- #081 Tempered Glass Camera Lens Protector (Others) -----
  {
    id: "081",
    name: {
      en: "9H Tempered Glass Camera Lens Protector (3-Pack)",
      ar: "حامي عدسة كاميرا زجاج مقوى 9H — حزمة 3 قطع",
      fr: "Protecteur d'objectif verre trempé 9H (pack de 3)",
    },
    category: "others", authentic: false,
    sizes: sizes(["3 Pack", 1]),
    originalPrice: 8,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/81.png", "/products/81.2.png", "/products/81.3.png"],
  },

  // ----- #082 Fashion Studio Wide Leg Pants (Clothing & Shoes) -----
  {
    id: "082",
    name: {
      en: "Fashion Studio Striped Wide-Leg Pants",
      ar: "بنطلون نسائي مخطط واسع الساق Fashion Studio",
      fr: "Pantalon large rayé Fashion Studio",
    },
    category: "clothing", authentic: false,
    color: { en: "Blue/White", ar: "أزرق/أبيض", fr: "Bleu/Blanc" },
    sizes: sizes(["Large", 1]),
    originalPrice: 22,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/82.png", "/products/82.2.png", "/products/82.3.png"],
  },

  // ----- #083 Braided Micro-USB Cable (Others) -----
  {
    id: "083",
    name: {
      en: "Braided Micro-USB Charging Cable",
      ar: "كابل شحن مايكرو USB مضفّر",
      fr: "Câble de charge Micro-USB tressé",
    },
    category: "others", authentic: false,
    color: { en: "Black/White", ar: "أسود/أبيض", fr: "Noir/Blanc" },
    sizes: sizes(["Micro USB", 1]),
    originalPrice: 3,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/83.png"],
  },

  // ----- #084 Tommy Hilfiger Girls Sweatshirt (Clothing — Authentic) -----
  {
    id: "084",
    name: {
      en: "Tommy Hilfiger Girls Red Logo Sweatshirt",
      ar: "سويتشيرت بناتي Tommy Hilfiger بشعار أحمر",
      fr: "Sweat-shirt fille Tommy Hilfiger logo rouge",
    },
    category: "clothing", authentic: true,
    color: { en: "Red", ar: "أحمر", fr: "Rouge" },
    sizes: sizes(["8 years", 1]),
    originalPrice: 55,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/84.png", "/products/84.2.png", "/products/84.3.png"],
  },

  // ----- #085 Nike Men's Basketball Tee (Clothing — Authentic) -----
  {
    id: "085",
    name: {
      en: "Nike Men's Basketball Graphic T-Shirt",
      ar: "تي شيرت رجالي Nike لكرة السلة برسومات",
      fr: "T-shirt homme Nike Basketball graphique",
    },
    category: "clothing", authentic: true,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    sizes: sizes(["XXL", 1]),
    originalPrice: 40,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/85.png", "/products/85.2.png", "/products/85.3.png"],
  },

  // ----- #086 Nike Women's Basketball Shorts (Clothing — Authentic) -----
  {
    id: "086",
    name: {
      en: "Nike Women's Basketball Shorts",
      ar: "شورت نسائي Nike لكرة السلة",
      fr: "Short femme Nike Basketball",
    },
    category: "clothing", authentic: true,
    color: { en: "White/Orange", ar: "أبيض/برتقالي", fr: "Blanc/Orange" },
    sizes: sizes(["XXL", 1]),
    originalPrice: 40,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/86.png", "/products/86.2.png", "/products/86.3.png"],
  },

  // ----- #087 Men's Striped Boxer Shorts (Clothing) -----
  {
    id: "087",
    name: {
      en: "Men's Striped Cotton Boxer Shorts",
      ar: "بوكسر رجالي قطني مخطط",
      fr: "Boxer rayé homme en coton",
    },
    category: "clothing", authentic: false,
    color: { en: "Blue/White", ar: "أزرق/أبيض", fr: "Bleu/Blanc" },
    sizes: sizes(["XS", 1]),
    originalPrice: 10,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/87.png", "/products/87.2.png", "/products/87.3.png"],
  },

  // ----- #088 Men's Striped Pajama Pants (Clothing) -----
  {
    id: "088",
    name: {
      en: "Men's Striped Cotton Pajama Pants",
      ar: "بنطلون بيجاما رجالي قطني مخطط",
      fr: "Pantalon de pyjama rayé homme en coton",
    },
    category: "clothing", authentic: false,
    color: { en: "Blue/White", ar: "أزرق/أبيض", fr: "Bleu/Blanc" },
    sizes: sizes(["Large", 1]),
    originalPrice: 15,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/88.png", "/products/88.2.png", "/products/88.3.png"],
  },

  // ----- #089 Women's Black Striped Wide Leg Pants (Clothing) -----
  {
    id: "089",
    name: {
      en: "Women's Black Striped Wide-Leg Pants",
      ar: "بنطلون نسائي مخطط أسود واسع الساق",
      fr: "Pantalon large rayé noir pour femme",
    },
    category: "clothing", authentic: false,
    color: { en: "Black/White", ar: "أسود/أبيض", fr: "Noir/Blanc" },
    sizes: sizes(["Large", 1]),
    originalPrice: 20,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/89.png", "/products/89.2.png", "/products/89.3.png"],
  },

  // ----- #090 Women's White Pull-On Slim Pants (Clothing) -----
  {
    id: "090",
    name: {
      en: "Women's White Pull-On Slim Pants",
      ar: "بنطلون نسائي ضيق أبيض ينتعل",
      fr: "Pantalon slim blanc à enfiler pour femme",
    },
    category: "clothing", authentic: false,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: sizes(["Large", 1]),
    originalPrice: 20,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/90.png", "/products/90.2.png", "/products/90.3.png"],
  },

  // ----- #091 Calvin Klein Girls Bikini Underwear 7-Pack (Clothing) -----
  {
    id: "091",
    name: {
      en: "Calvin Klein Girls Bikini Underwear (7-Pack)",
      ar: "ملابس داخلية بناتي Calvin Klein بيكيني — حزمة 7 قطع",
      fr: "Sous-vêtements bikini fille Calvin Klein (pack de 7)",
    },
    category: "clothing", authentic: false,
    color: { en: "Assorted", ar: "ألوان متنوّعة", fr: "Assortis" },
    sizes: sizes(["Medium / 7 Pack", 1]),
    originalPrice: 40,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/91.png", "/products/91.1.png"],
  },

  // ----- #092 PrimeMD Collagen Peptides (Supplements — Authentic) -----
  {
    id: "092",
    name: {
      en: "PrimeMD Collagen Peptides — Hair, Skin & Nails (90 Capsules)",
      ar: "PrimeMD ببتيدات كولاجين للشعر والبشرة والأظافر — 90 كبسولة",
      fr: "PrimeMD Peptides de Collagène — Cheveux, Peau & Ongles (90 capsules)",
    },
    category: "cosmetics", authentic: true,
    sizes: sizes(["90 capsules", 1]),
    originalPrice: 50,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/92.png", "/products/92.2.png", "/products/92.3.png"],
  },

  // ----- #093 Secret Outlast Clear Gel (Supplements — Authentic) -----
  {
    id: "093",
    name: {
      en: "Secret Outlast Sweat & Odor Clear Gel Antiperspirant — Completely Clean",
      ar: "Secret Outlast جل مزيل تعرّق شفاف — كومبليتلي كلين",
      fr: "Secret Outlast gel anti-transpirant transparent — Completely Clean",
    },
    category: "cosmetics", authentic: true,
    color: { en: "Completely Clean", ar: "كومبليتلي كلين", fr: "Completely Clean" },
    sizes: sizes(["2.6 oz / 73 g", 3]),
    originalPrice: 12,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/93.png", "/products/93.2.png"],
  },

  // ----- #094 Secret pH Balanced Solid (Supplements — Authentic) -----
  {
    id: "094",
    name: {
      en: "Secret pH Balanced Invisible Solid Antiperspirant — Powder Fresh",
      ar: "Secret مزيل تعرّق صلب متوازن مع رائحة باودر فريش",
      fr: "Secret anti-transpirant solide pH équilibré — Powder Fresh",
    },
    category: "cosmetics", authentic: true,
    color: { en: "Powder Fresh", ar: "باودر فريش", fr: "Powder Fresh" },
    sizes: sizes(["2.6 oz / 73 g", 1]),
    originalPrice: 10,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/94.png", "/products/94.2.png"],
  },

  // ----- #095 Puma Kids White Sneakers (Clothing — Authentic) -----
  {
    id: "095",
    name: {
      en: "Puma Kids White Sneakers with Velcro Straps",
      ar: "حذاء Puma أطفال أبيض بأشرطة فيلكرو",
      fr: "Baskets enfant Puma blanches à scratch",
    },
    category: "clothing", authentic: true,
    color: { en: "White", ar: "أبيض", fr: "Blanc" },
    sizes: sizes(["EU 27", 1]),
    originalPrice: 50,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/95.png", "/products/95.2.png", "/products/95.3.png"],
  },

  // ----- #096 Puma Kids Socks 10-Pack (Clothing — Authentic) -----
  {
    id: "096",
    name: {
      en: "Puma Kids Low Crew Socks — Multicolor (10-Pack)",
      ar: "جوارب Puma أطفال متعدّدة الألوان — حزمة 10 أزواج",
      fr: "Chaussettes basses enfant Puma multicolores (pack de 10)",
    },
    category: "clothing", authentic: true,
    color: { en: "Multicolor", ar: "متعدّد الألوان", fr: "Multicolore" },
    sizes: sizes(["Size 9 / 10 Pack", 1]),
    originalPrice: 25,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/96.png"],
  },

  // ----- #097 Puma Kids Socks 10-Pack (duplicate item) (Clothing — Authentic) -----
  {
    id: "097",
    name: {
      en: "Puma Kids Low Crew Socks — Multicolor (10-Pack)",
      ar: "جوارب Puma أطفال متعدّدة الألوان — حزمة 10 أزواج",
      fr: "Chaussettes basses enfant Puma multicolores (pack de 10)",
    },
    category: "clothing", authentic: true,
    color: { en: "Multicolor", ar: "متعدّد الألوان", fr: "Multicolore" },
    sizes: sizes(["Size 9 / 10 Pack", 1]),
    originalPrice: 25,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/97.png"],
  },

  // ----- #098 Skechers Women's Socks 8-Pack (Clothing — Authentic) -----
  {
    id: "098",
    name: {
      en: "Skechers Women's Low Crew Socks — Assorted (8-Pack)",
      ar: "جوارب نسائي Skechers بألوان متنوّعة — حزمة 8 أزواج",
      fr: "Chaussettes basses femme Skechers assorties (pack de 8)",
    },
    category: "clothing", authentic: true,
    color: { en: "Assorted", ar: "ألوان متنوّعة", fr: "Assorties" },
    sizes: sizes(["Women's 6–9.5 / 8 Pack", 1]),
    originalPrice: 30,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/98.png", "/products/98.2.png"],
  },

  // ----- #099 Amazon Basics Kids Multivitamin (Supplements — Authentic) -----
  {
    id: "099",
    name: {
      en: "Amazon Basics Kids' Multivitamin Gummies (190 Gummies)",
      ar: "حلاوة فيتامينات Amazon Basics للأطفال — 190 حبة",
      fr: "Gummies multivitamines pour enfants Amazon Basics (190 pcs)",
    },
    category: "cosmetics", authentic: true,
    color: { en: "Orange, Cherry & Strawberry", ar: "برتقال، كرز، فراولة", fr: "Orange, Cerise & Fraise" },
    sizes: sizes(["190 gummies", 1]),
    originalPrice: 25,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/99.png", "/products/99.2.png"],
  },

  // ----- #100 Estée Lauder Double Wear (Supplements — Authentic) -----
  {
    id: "100",
    name: {
      en: "Estée Lauder Double Wear Stay-in-Place Foundation",
      ar: "Estée Lauder كريم أساس Double Wear ثابت طويل الأمد",
      fr: "Fond de teint Estée Lauder Double Wear longue tenue",
    },
    category: "cosmetics", authentic: true,
    color: { en: "7C1 Rich Mahogany", ar: "7C1 ريتش ماهوغاني", fr: "7C1 Rich Mahogany" },
    sizes: sizes(["1 fl oz / 30 ml", 1]),
    originalPrice: 55,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/100.png", "/products/100.2.png", "/products/100.3.png"],
  },

  // ----- #101 Anastasia Beverly Hills Stick (Supplements — Authentic) -----
  {
    id: "101",
    name: {
      en: "Anastasia Beverly Hills Stick Contour + Highlight",
      ar: "Anastasia Beverly Hills قلم كنتور وهايلايتر",
      fr: "Anastasia Beverly Hills stick contour + enlumineur",
    },
    category: "cosmetics", authentic: true,
    color: { en: "Shadow", ar: "شادو", fr: "Shadow" },
    sizes: sizes(["9 g / 0.32 oz", 1]),
    originalPrice: 30,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/101.png", "/products/101.2.png", "/products/101.3.png"],
  },

  // ----- #102 Calvin Klein Jeans Yellow Dress (Clothing — Authentic) -----
  {
    id: "102",
    name: {
      en: "Calvin Klein Jeans Yellow Fitted T-Shirt Dress",
      ar: "فستان Calvin Klein Jeans أصفر ضيق على شكل تي شيرت",
      fr: "Robe T-shirt cintrée Calvin Klein Jeans jaune",
    },
    category: "clothing", authentic: true,
    color: { en: "Light Yellow", ar: "أصفر فاتح", fr: "Jaune clair" },
    sizes: sizes(["Medium", 1]),
    originalPrice: 69,
    tags: ["new"],
    addedDate: "2026-05-19",
    images: ["/products/102.png", "/products/102.1.png", "/products/102.3.png"],
  },
  // ----- #451 (added 2026-06-08) -----
  {
    id: "451",
    name: { en: "Patio Rocking Chair Outdoor Chair with Cushion Padded, Indoor Oversized Rattan Wicker Lounge Chair, Metal Frame Large Supports Modern Rocker", ar: "Patio Rocking Chair Outdoor Chair with Cushion Padded, Indoor Oversized Rattan Wicker Lounge Chair, Metal Frame Large Supports Modern Rocker", fr: "Patio Rocking Chair Outdoor Chair with Cushion Padded, Indoor Oversized Rattan Wicker Lounge Chair, Metal Frame Large Supports Modern Rocker" },
    category: "others", authentic: false,
    color: { en: "green", ar: "green", fr: "green" },
    quantity: 1,
    originalPrice: 260.0,
    discountPct: 50,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: ["/products/451.jpeg", "/products/451.2.jpeg", "/products/451.3.jpeg", "/products/451.4.jpeg", "/products/451.5.jpeg", "/products/451.6.jpeg"],
  },
  // ----- #452 (added 2026-06-08) -----
  {
    id: "452",
    name: { en: "Bitcoin LED Wall Light Sign – Gold Metal Frame – 100 cm", ar: "Bitcoin LED Wall Light Sign – Gold Metal Frame – 100 cm", fr: "Bitcoin LED Wall Light Sign – Gold Metal Frame – 100 cm" },
    category: "others", authentic: false,
    quantity: 1,
    originalPrice: 500.0,
    discountPct: 50,
    addedDate: "2026-06-08",
    tags: ["new"],
    images: ["/products/452.jpeg", "/products/452.1.jpeg", "/products/452.2.jpeg"],
  },
  // ----- #453 (posted Shop For Less 2026-09-15; size/price not provided) -----
  {
    id: "453",
    name: { en: "Women’s Pink Rhinestone Logo Crop Cami", ar: "Women’s Pink Rhinestone Logo Crop Cami", fr: "Women’s Pink Rhinestone Logo Crop Cami" },
    description: { en: "Spaghetti-strap crop cami with a rhinestone logo at the chest.", ar: "Spaghetti-strap crop cami with a rhinestone logo at the chest.", fr: "Spaghetti-strap crop cami with a rhinestone logo at the chest." },
    category: "clothing", authentic: false,
    color: { en: "Pink", ar: "وردي", fr: "Rose" },
    quantity: 1,
    originalPrice: null,
    addedDate: "2026-09-15",
    tags: ["new"],
    images: ["/products/453.jpg", "/products/453.2.jpg"],
  },
  // ----- #454 (posted Shop For Less 2026-09-15; size/price omitted by request) -----
  {
    id: "454",
    name: { en: "Women’s Black Floral Lace Bralette & Shorts Set", ar: "Women’s Black Floral Lace Bralette & Shorts Set", fr: "Women’s Black Floral Lace Bralette & Shorts Set" },
    description: { en: "Floral lace bralette with matching lace shorts.", ar: "Floral lace bralette with matching lace shorts.", fr: "Floral lace bralette with matching lace shorts." },
    category: "clothing", authentic: false,
    color: { en: "Black", ar: "أسود", fr: "Noir" },
    quantity: 1,
    originalPrice: null,
    addedDate: "2026-09-15",
    tags: ["new"],
    images: ["/products/454.jpg", "/products/454.2.jpg"],
  },
  // ----- #455 (posted Shop For Less 2026-09-15; size/price not in caption or photos) -----
  {
    id: "455",
    name: { en: "Women’s Red Lace Chemise", ar: "Women’s Red Lace Chemise", fr: "Women’s Red Lace Chemise" },
    description: { en: "Red floral lace slip with a scalloped hem and open back.", ar: "Red floral lace slip with a scalloped hem and open back.", fr: "Red floral lace slip with a scalloped hem and open back." },
    category: "clothing", authentic: false,
    color: { en: "Red", ar: "أحمر", fr: "Rouge" },
    quantity: 1,
    originalPrice: null,
    addedDate: "2026-09-15",
    tags: ["new"],
    images: ["/products/455.jpg", "/products/455.2.jpg", "/products/455.3.jpg"],
  },
];

// Combined catalog used by lookup helpers (cart, detail, recently viewed, stock seed).
// PRODUCTS stays BOB-only so the main store grid / homepage preview never mix
// SHEIN items into "All". SHEIN products are surfaced via dedicated UI (SheinPage).
export const ALL_PRODUCTS = [...PRODUCTS, ...SHEIN_PRODUCTS];

// ---------- helpers ----------
// Number of days the "New" badge stays visible after a product's `addedDate`.
// Past this window the badge auto-hides — the product itself stays available.
export const NEW_BADGE_DAYS = 7;

/**
 * Returns true if the product was added within the last NEW_BADGE_DAYS days.
 * Driven by an ISO `addedDate` field on the product (set to the upload date
 * when a new product is registered). Products without `addedDate` are
 * treated as not-new — this lets the badge disappear cleanly for older
 * items that previously used the legacy `tags: ["new"]` marker.
 */
export const isProductNew = (product, now = Date.now()) => {
  if (!product || !product.addedDate) return false;
  const added = new Date(product.addedDate).getTime();
  if (Number.isNaN(added)) return false;
  const diffDays = (now - added) / (1000 * 60 * 60 * 24);
  return diffDays >= 0 && diffDays <= NEW_BADGE_DAYS;
};

export const computeDiscountedPrice = (originalPrice, discountPct) => {
  if (originalPrice == null) return null;
  const pct = typeof discountPct === "number" ? discountPct : DISCOUNT_PERCENT;
  return Math.round(originalPrice * (1 - pct / 100) * 100) / 100;
};

// Per-product discount percentage — SHEIN products use 30% off, every other
// product follows the platform-wide DISCOUNT_PERCENT (50%).
export const getProductDiscountPct = (product) => {
  if (!product) return DISCOUNT_PERCENT;
  if (typeof product.discountPct === "number") return product.discountPct;
  return DISCOUNT_PERCENT;
};

// Convenience: discounted price for a specific product using its rate.
export const productPrice = (product) =>
  computeDiscountedPrice(product?.originalPrice, getProductDiscountPct(product));

export const formatPrice = (value) => {
  if (value == null) return "—";
  return `${CURRENCY}${Number(value).toFixed(2)}`;
};

const isZeroSizeLabel = (label) => {
  const v = String(label || "").trim();
  return v === "0" || v === "0:0";
};

export const catalogMarksOutOfStock = (product) => {
  if (!product) return false;
  if (Number(product.quantity) === 0) return true;
  const sizes = Array.isArray(product.sizes) ? product.sizes : [];
  if (sizes.length && sizes.every((s) => isZeroSizeLabel(s?.label) || Number(s?.qty) === 0)) {
    return true;
  }
  return false;
};

export const effectiveSizeQty = (sizeEntry) => {
  if (!sizeEntry) return 0;
  if (isZeroSizeLabel(sizeEntry.label)) return 0;
  if (sizeEntry.qty == null) return null;
  const n = Number(sizeEntry.qty);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, n);
};

// "available" semantics:
// - priceTBD = true → not orderable
// - Admin explicit 0 (size field "0" or qty 0) always wins over leftover live stock
// - live stock map (Admin Stock / product_stocks) otherwise
// - sizes present: at least one size has qty > 0
// - else: quantity > 0
export const isAvailable = (product, liveStock) => {
  if (product?.originalPrice == null) return false;
  if (catalogMarksOutOfStock(product)) return false;
  if (liveStock && typeof liveStock === "object") {
    if (liveStock.has_sizes) {
      return Object.values(liveStock.sizes || {}).some((q) => {
        if (q && typeof q === "object") {
          return Object.values(q).some((inner) => Number(inner) > 0);
        }
        return Number(q) > 0;
      });
    }
    if (liveStock.qty != null || liveStock.quantity != null) {
      return Number(liveStock.qty ?? liveStock.quantity ?? 0) > 0;
    }
  }
  if (typeof product.stock === "number") return product.stock > 0;
  if (Array.isArray(product.sizes) && product.sizes.length) {
    return product.sizes.some((s) => {
      const q = effectiveSizeQty(s);
      return q == null || q > 0;
    });
  }
  return Number(product.quantity ?? 0) > 0;
};

// available qty for a specific size label (null = unknown/unlimited stock)
export const sizeQty = (product, sizeLabel) => {
  if (catalogMarksOutOfStock(product)) return 0;
  if (!Array.isArray(product.sizes)) return product.quantity ?? null;
  const s = product.sizes.find((x) => x.label === sizeLabel);
  if (!s) return 0;
  return effectiveSizeQty(s);
};

export const isSizeAvailable = (product, sizeLabel) => {
  const q = sizeQty(product, sizeLabel);
  if (q === null) return true; // unknown qty = treat as available
  return q > 0;
};

export const getProductById = (id) => ALL_PRODUCTS.find((p) => p.id === id);

export const getProductBySlug = (slug) => {
  const id = (slug || "").replace(/^product-/, "");
  return getProductById(id);
};

export const productSlug = (id) => `product-${id}`;

export const localized = (field, lang) => {
  if (!field) return "";
  if (typeof field === "string") return field;
  return field[lang] || field.en || "";
};

// ---------------------------------------------------------------------------
// Variant helpers (size + color combinations)
// ---------------------------------------------------------------------------
// A variant key uniquely identifies a sellable variant of a product:
//   - both size and color : "M::Dark Brown"
//   - size only           : "M"
//   - color only          : "Dark Brown"
//   - no variants         : ""
// We store stock using these strings under the `sizes` map so the backend
// schema doesn't need to change.
export const variantKey = (size, color) => {
  const s = (size || "").trim();
  const c = (color || "").trim();
  if (s && c) return `${s}::${c}`;
  return s || c || "";
};

// Return the array of selectable colors for a product (always English `.en`
// labels — UI components handle their own translation lookups).
export const productColorEnList = (product) => {
  if (!product) return [];
  if (Array.isArray(product.colors) && product.colors.length > 0) {
    return product.colors.map((c) => (typeof c === "string" ? c : c.en));
  }
  return [];
};

// Get the localized label for a single color value on a product. The product
// may carry `colors: [{en, ar, fr}]` (multi-color) or `color: {en, ar, fr}`
// (single-color, no selector needed).
export const localizedColor = (product, colorEn, lang) => {
  if (!product || !colorEn) return colorEn || "";
  if (Array.isArray(product.colors)) {
    const found = product.colors.find(
      (c) => (typeof c === "string" ? c : c.en) === colorEn
    );
    if (found) return localized(found, lang);
  }
  if (product.color) return localized(product.color, lang);
  return colorEn;
};

// ---------------------------------------------------------------------------
// Stock seed — initial values shipped to the backend ONCE on storefront mount.
// Backend is the source of truth after sales; this only seeds missing rows.
// ---------------------------------------------------------------------------
export const stockSeedItems = () =>
  ALL_PRODUCTS.map((p) => {
    const hasSizes = Array.isArray(p.sizes) && p.sizes.length > 0;
    const hasColors = Array.isArray(p.colors) && p.colors.length > 0;

    if (hasSizes && hasColors) {
      // size × color matrix — each combination gets the per-size qty (default 1)
      const sizes = {};
      for (const s of p.sizes) {
        const qty = s.qty == null ? 1 : Number(s.qty) || 0;
        for (const c of p.colors) {
          const colorEn = typeof c === "string" ? c : c.en;
          sizes[variantKey(s.label, colorEn)] = qty;
        }
      }
      return { product_id: p.id, qty: 0, sizes, has_sizes: true };
    }

    if (hasColors) {
      // color-only — each color is its own variant with qty 1 (or product.quantity)
      const sizes = {};
      const perVariant =
        p.quantity == null ? 1 : Math.max(1, Math.floor(Number(p.quantity) / p.colors.length) || 1);
      for (const c of p.colors) {
        const colorEn = typeof c === "string" ? c : c.en;
        sizes[variantKey("", colorEn)] = perVariant;
      }
      return { product_id: p.id, qty: 0, sizes, has_sizes: true };
    }

    if (hasSizes) {
      // size-only — existing behaviour
      const sizes = {};
      for (const s of p.sizes) {
        sizes[s.label] = s.qty == null ? 1 : Number(s.qty) || 0;
      }
      return { product_id: p.id, qty: 0, sizes, has_sizes: true };
    }

    // no variants — single SKU
    return {
      product_id: p.id,
      qty: p.quantity == null ? 1 : Number(p.quantity) || 0,
      sizes: {},
      has_sizes: false,
    };
  });

